import { mockBuilder } from '../utils/builderHelper.es.js';
import { SocialExternalUrl, SocialPublicUrl } from './Social.es.js';

/** @module Mocks */ /** typedoc */
/**
 * Create an external url object for Itunes
 * @returns {SocialExternalUrl}
 */
function aSocialExternalUrlForItunes() {
    return mockBuilder(new SocialExternalUrl('iTunes', 'https://itunes.apple.com/us/album/better-together/id879273552?i=879273565'));
}
/**
 * Create an external url object for Spotify
 * @returns {SocialExternalUrl}
 */
function aSocialExternalUrlForSpotify() {
    return mockBuilder(new SocialExternalUrl('Spotify', 'https://open.spotify.com/album/1YbA3JApZ3JPQT3aKCjEhL'));
}
/**
 * Create a social public url for a Release (AKA Smartlink)
 * @returns {SocialPublicUrl}
 */
function aSocialPublicUrlForRelease() {
    return mockBuilder(new SocialPublicUrl('https://artist-dev.landr.com', '/music', '800001007578'));
}

export { aSocialExternalUrlForItunes, aSocialExternalUrlForSpotify, aSocialPublicUrlForRelease };
